import { render, staticRenderFns } from "./ProcessGdpr.vue?vue&type=template&id=1f6dd31e&scoped=true&"
import script from "./ProcessGdpr.vue?vue&type=script&lang=js&"
export * from "./ProcessGdpr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6dd31e",
  null
  
)

export default component.exports